import Index from '@/views/common/Index'
import User from '@/views/system/user/User'
import Role from '@/views/system/role/Role'
import Resource from '@/views/system/resource/Resource'
import Permission from '@/views/system/permission/Permission'
import Codelist from '@/views/system/codelist/Codelist'
import Organization from '@/views/system/organization/Organization'
import Mail from '@/views/system/mail/Mail'

export default [
{
  path: '/index',
  name: 'index',
  redirect: 'home',
  meta: {
    auth: true
  },
  component: Index,
  children: [
    {
      path: '/system/user',
      meta: {
        auth: true,
        title: "用户管理",
        isRedirect: true
      },
      component: User,
      children: [{
        path: '/',
        name: 'user',
        component: resolve => require(['@/views/system/user/UserList'], resolve)
      },
      {
        path: '/system/user/insert',
        meta: {
          auth: true,
          title: "用户新增"
        },
        name: 'userAdd',
        component: resolve => require(['@/views/system/user/UserEdit'], resolve)
      },
      {
        path: '/system/user/update',
        meta: {
          auth: true,
          title: "用户编辑"
        },
        name: 'userEdit',
        component: resolve => require(['@/views/system/user/UserEdit'], resolve)
      }]
    },
    //----------系统管理-角色管理----------
    {
      path: '/system/role',
      meta: {
        auth: true,
        title: "角色管理",
        isRedirect: true
      },
      component: Role,
      children: [{
        path: '/',
        name: 'role',
        component: resolve => require(['@/views/system/role/RoleList'], resolve)
      },]
    },
    //----------系统管理-资源管理----------
    {
      path: '/system/resource',
      meta: {
        auth: true,
        title: "资源管理",
        isRedirect: true
      },
      component: Resource,
      children: [{
        path: '/',
        name: 'resource',
        component: resolve => require(['@/views/system/resource/ResourceList'], resolve)
      },]
    },
    //----------系统管理-权限管理----------
    {
      path: '/system/permission',
      meta: {
        auth: true,
        title: "权限管理",
        isRedirect: true
      },
      component: Permission,
      children: [{
        path: '/',
        name: 'permission',
        component: resolve => require(['@/views/system/permission/PermissionList'], resolve)
      },]
    },
    //----------系统管理-代码集管理----------
    {
      path: '/system/codelist',
      meta: {
        auth: true,
        title: "代码集管理",
        isRedirect: true
      },
      component: Codelist,
      children: [{
        path: '/',
        name: 'codelist',
        meta: {
          keepAlive: false
        },
        component: resolve => require(['@/views/system/codelist/CodelistList'], resolve)
      },
      {
        path: '/system/codelist/detail',
        name: 'codelist/detail',
        meta: {
          auth: true,
          title: "代码集详情",
          keepAlive: false
        },
        component: resolve => require(['@/views/system/codelist/CodelistDetail'], resolve)
      },
      ]
    },
    //----------系统管理-组织机构管理----------

    {
      path: '/system/organization',
      meta: {
        auth: true,
        title: "组织机构管理",
        isRedirect: true
      },
      component: Organization,
      children: [{
        path: '/',
        name: 'organization',
        component: resolve => require(['@/views/system/organization/OrganizationList'], resolve)
      }]
    },

    //----------系统管理-邮箱管理----------
    {
      path: '/system/mail',
      meta: {
        auth: true,
        title: "邮箱管理",
        isRedirect: true
      },
      component: Mail,
      children: [{
        path: '/',
        name: 'mail',
        component: resolve => require(['@/views/system/mail/MailList'], resolve)
      },]
    }
  ]
}]


// WEBPACK FOOTER //
// ./src/router/system.js